import { gql } from "@apollo/client";

export const GET_HEIGHT_SYMTEMS = gql`
  query heightSystemType {
    heightSystemType {
      HeightSystemTypeId
      Name
    }
  }
`;

export const GET_COORD_SYMTEMS = gql`
  query coordinateSystemTypes {
    coordinateSystemTypes {
      CoordinateSystemTypeId
      Name
      DatumCode
    }
  }
`;
